export default __webpack_public_path__ + "static/media/profile.aa950fe9.svg";